import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import vehiclesData from "../../data/vehiclesData";
import VehicleServicesCard from "../../components/cards/VehicleServicesCard/VehicleServicesCard";
import './ServicesPage.css'
import AftersalesSupportSection from "../../components/sections/AftersalesSupportSection/AftersalesSupportSection";

export default function ServicesPage() {

    const vehiclesWithServices = vehiclesData.filter(
        (v) => v.servicePackages && v.servicePackages.variants?.length > 0
    );


    return (
        <div className="Page">
            <div className="servicesPageBanner text-center">
                <div className="page-banner-content">
                    <h3>
                        Transparent Maintenance
                    </h3>
                    <h1>
                        Predictable Costs
                    </h1>
                </div>
            </div>

            <Container fluid>
                <div className="section-spacing">
                    <p className="brand-section-desc text-center mb-0">Choose from kilometer-based service plans designed to keep your truck performing reliably while giving you complete clarity on pricing.</p>
                </div>


                <Row className="gy-4">
                    {vehiclesWithServices.map((vehicle) => (
                        <Col key={vehicle.id} xs={12} md={6} lg={4}>
                            <VehicleServicesCard vehicle={vehicle} />
                        </Col>
                    ))}
                </Row>

            </Container>

            <div className="section-spacing-top">
                <AftersalesSupportSection />
            </div>
        </div>
    );
}